import {initSentry} from "./sentry";
import React, {Suspense} from "react";
import {configure} from "mobx";
import {Provider} from "mobx-react";
import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import * as serviceWorker from "./serviceWorker";
import {BrowserRouter} from "react-router-dom";
//local
import "./assets/styles/app.scss";
import {App} from "./App";
import store from "./store/index";
import {Preloader} from "components/Preloader";
import "./index.css";
import "./locale";
import {SentryErrorBoundary} from "components/SentryErrorBoundary";
initSentry();

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

configure({
  enforceActions: "never",
});

root.render(
  <StrictMode>
    <SentryErrorBoundary>
      <Suspense fallback={<Preloader />}>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </Suspense>
    </SentryErrorBoundary>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
